import { render, staticRenderFns } from "./organLists.vue?vue&type=template&id=addd78c2&scoped=true&"
import script from "./organLists.vue?vue&type=script&lang=js&"
export * from "./organLists.vue?vue&type=script&lang=js&"
import style0 from "./organLists.vue?vue&type=style&index=0&id=addd78c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addd78c2",
  null
  
)

export default component.exports